import templateUrl from "emun.salesrep/territory-manager/repassignment/repassignment-prompt.htm";
import RepAssignmentPromptController from "emun.salesrep/territory-manager/repassignment/repassignment-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const RepAssignmentPrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'lg quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
		controller: RepAssignmentPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default RepAssignmentPrompt;
